import { setTranslation } from "../../i18n";
import { ICreateProduct, IProductFormValues } from "../types";

export const mapProductToCreate = (values: IProductFormValues): ICreateProduct => {
  return {
    name: setTranslation(values.name),
    brand: setTranslation(values.brand),
    description: setTranslation(values.description),
    //type: values.type,
    temperature: values.temperature,
    pickingType: values.pickingType,
    price: values.price ? { default: { price: Number(values.price), sublines: [] } } : undefined,
    image: values.image,
    displaySize: values.displaySize,
    heightMm: values.heightMm,
    weightKg: values.weightKg,
    volumeL: values.volumeL,
    lengthMm: values.lengthMm,
    categoryId: values.categoryId && !isNaN(Number(values.categoryId)) ? Number(values.categoryId) : undefined,
    widthMm: values.widthMm,
    barcodes: values.barcodes
  }
}